module.exports = __webpack_public_path__ + "static/media/YM20_3.2de89083.jpg";